import {AbstractService} from 'services/AbstractService';


const CONTRACT_DETAILS_URL = '/api/contracts/{0}';

export class ContractsService extends AbstractService {
  async getContract (accountId, contractId) {
    return await this.client.get(CONTRACT_DETAILS_URL.format(contractId));
  }
}
